export const GET_PROMO_LIST = "GET_PROMO_LIST";
export const GET_PROMO_LIST_EXPIRED = "GET_PROMO_LIST_EXPIRED";
export const GET_REMINDER_LIST = "GET_REMINDER_LIST";
export const GET_BIRTHDAY_LIST = "GET_BIRTHDAY_LIST";
export const GET_CLIENT_LIST = "GET_CLIENT_LIST";
export const ADD_PROMOTION = "ADD_PROMOTION";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const UPDATE_BIRTHDAY = "UPDATE_BIRTHDAY";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const GET_GROUP_BY_ID = "GET_GROUP_BY_ID";
export const GET_PROMOTION_DETAIL = "GET_PROMOTION_DETAIL";
export const GET_REMINDER_DETAIL = "GET_REMINDER_DETAIL";
export const GET_BIRTHDAY_DETAIL = "GET_BIRTHDAY_DETAIL";
export const CHECK_LIMIT_PROMOTION = "CHECK_LIMIT_PROMOTION";
export const CHECK_OPT_OUT_REQUIRED = "CHECK_OPT_OUT_REQUIRED";
export const SEND_TEST = "SEND_TEST";
export const GET_CAMPAIGN_HISTORY_LIST = "GET_CAMPAIGN_HISTORY_LIST";